const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const Sounds = require("../../core/util/Sounds");
const AssetsUtil = require("../../core/util/AssetsUtil");

const styles = require("./styles/ScrollableButtons.css");

module.exports = createReactClass({
	displayName: "ScrollableButtons",

	propTypes: {
		className: PT.string.isRequired,
		buttons: PT.array.isRequired,
		scrollIndex: PT.number,
		selectedIndex: PT.number.isRequired,
		//If it needs to scroll, how many buttons are visible at a time
		numScrollButtons: PT.number.isRequired,
		//The number of buttons after which the view should scroll
		scrollCutoff: PT.number.isRequired,
		buttonSize: PT.number.isRequired,
		arrowColor: PT.string,
		onIndexChange: PT.func,
	},

	getInitialState: function() {
		return {
			//Value keeping track of the leftmost index in the current view of scrollable buttons.
			scrollIndex: this.props.scrollIndex || 0,
		};
	},

	statics: {
		getDerivedStateFromProps(props, prevState) {
			const getAdjustedIndex = function() {
				const {scrollIndex, selectedIndex} = prevState;
				const {numScrollButtons} = props;
				// Make sure selected button is within visible buttons
				if (selectedIndex < scrollIndex) {
					return selectedIndex;
				} else if (selectedIndex >= scrollIndex + numScrollButtons) {
					return selectedIndex - numScrollButtons + 1;
				}
				return scrollIndex;
			};
			return {scrollIndex: getAdjustedIndex()};
		},
	},

	componentWillUnmount: function() {
		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}
	},

	createScrollButton: function(type, cellStyleOriginal, cellSize) {
		const {buttons, numScrollButtons, arrowColor} = this.props;
		const cellStyle = _.clone(cellStyleOriginal);
		const scrollIndex = this.state.scrollIndex;
		const numButtons = buttons.length;
		if (
			(type === "left" && scrollIndex === 0) ||
			(type === "right" && scrollIndex === numButtons - numScrollButtons)
		) {
			cellStyle.pointerEvents = "none";
			cellStyle.opacity = 0;
		}
		cellStyle.zIndex = 3;
		cellStyle.width = Math.min(50, cellStyle.width);
		cellStyle.height = Math.min(50, cellStyle.height);
		const iconType = arrowColor
			? "progress-button-" + type + "-" + arrowColor
			: "progress-button-" + type;
		const imgSrc = AssetsUtil.getGeneralIcon(iconType);
		//Compute the img size:
		const buttonSize = Math.min(50, Math.round(cellSize * 0.8));
		const imgStyle = {
			width: buttonSize,
			height: buttonSize,
		};
		const sound = type === "left" ? "arrow-left" : "arrow-right";
		return (
			<div
				className={styles.scrollCell}
				key={"scroll-" + type}
				style={cellStyle}
			>
				<img
					className={styles.scroll}
					style={imgStyle}
					src={imgSrc}
					onClick={() => Sounds.playSound(sound)}
					onMouseDown={evt => this.onScrollMouseDown(type)}
					onMouseUp={evt => this.onScrollMouseUp(type)}
				/>
			</div>
		);
	},

	onScrollMouseDown: function(direction) {
		this.isHoldingDown = false;
		this.scrollTimeout = setTimeout(() => this.onScrollHold(direction), 50);
	},

	onScrollHold: function(direction) {
		this.isHoldingDown = true;
		const keepScrolling = this.scroll(direction);
		if (keepScrolling) {
			this.scrollTimeout = setTimeout(() => this.onScrollHold(direction), 200);
		}
	},

	onScrollMouseUp: function(direction) {
		clearTimeout(this.scrollTimeout);
		if (this.isHoldingDown) {
			this.isHoldingDown = false;
		} else {
			this.scroll(direction);
		}
	},

	// Called by a parent
	scrollTo: function(index) {
		const {buttons, numScrollButtons, onIndexChange} = this.props;
		const newScrollIndex = _.clamp(index, 0, buttons.length - numScrollButtons);
		if (this.state.scrollIndex !== newScrollIndex) {
			this.setState({scrollIndex: newScrollIndex});
			onIndexChange && onIndexChange(newScrollIndex);
		}
	},

	// Takes in a direction, a string "left" or "right" and returns a boolean indicating
	// whether the view can continue to scroll in that direction
	// Also scrolls the index via setState if it needs to.
	scroll: function(direction) {
		const {buttons, numScrollButtons, onIndexChange} = this.props;
		const adjustment = direction === "left" ? -1 : 1;
		const newScrollIndex = _.clamp(
			this.state.scrollIndex + adjustment,
			0,
			buttons.length - numScrollButtons
		);
		if (this.state.scrollIndex !== newScrollIndex) {
			this.setState({scrollIndex: newScrollIndex});
			onIndexChange && onIndexChange(newScrollIndex);
			return true;
		}
		return false;
	},

	getCellStyle: function(cellSize, isVisible) {
		return {
			width: cellSize,
			height: cellSize,
			opacity: isVisible ? 1 : 0,
			transform: isVisible ? "scale(1,1)" : "scale(0,0)",
		};
	},

	render: function() {
		const {
			buttons,
			scrollCutoff,
			numScrollButtons,
			buttonSize,
			className,
		} = this.props;
		const numButtons = buttons.length;
		const numVisibleButtons =
			numButtons > scrollCutoff ? numScrollButtons : numButtons;

		let buttonEls = buttons.map((button, i) => {
			const isVisible =
				this.state.scrollIndex <= i &&
				i < this.state.scrollIndex + numVisibleButtons;
			return (
				<div
					className={styles.buttonCell}
					key={"p" + (i + 1)}
					style={this.getCellStyle(buttonSize, isVisible)}
				>
					{button}
				</div>
			);
		});

		if (numButtons > scrollCutoff) {
			const scrollIndex = this.state.scrollIndex;
			buttonEls = _.concat(
				this.createScrollButton(
					"left",
					this.getCellStyle(buttonSize, true),
					buttonSize
				),
				buttonEls,
				this.createScrollButton(
					"right",
					this.getCellStyle(buttonSize, true),
					buttonSize
				)
			);

			const padding = buttonSize / 3;

			const containerStyle = {
				width: buttonSize * numScrollButtons + 2 * padding,
				height: buttonSize,
				marginLeft: -1 * padding,
				marginRight: -1 * padding,
			};

			const innerStyle = {
				width: buttonSize * (buttonEls.length - 2),
				left: -scrollIndex * buttonSize + padding,
			};

			return (
				<div className={className}>
					{buttonEls[0]}
					<div className={styles.container} style={containerStyle}>
						<div className={styles.inner} style={innerStyle}>
							{buttonEls.slice(1, buttonEls.length - 1)}
						</div>
					</div>
					{_.last(buttonEls)}
				</div>
			);
		} else {
			return <div className={className}>{buttonEls}</div>;
		}
	},
});
